import { createAction, props } from '@ngrx/store';
import { LocationFacebookTokenPair, FacebookAuthResult, ReviewModel, SocialSharingTemplateSettings, RequestModel } from '@models/index';
import { SocialSharingScheduleSettings, SocialSharingScheduleType } from '@models/socialSharingScheduleSettings.model';
import { FacebookErrorModel } from '@models/facebookError.model';
import { FacebookTokenTypes } from '@enums/facebookTokenTypes.enum';

export const reset = createAction(
  '[Facebook] Reset'
)

export const clearState = createAction(
  '[Facebook] Clear State'
)

export const error = createAction(
  '[Facebook] Error',
  props<{ message: string, cause?: any }>()
)

export const searchFacebookPagesByLocation = createAction(
  '[Facebook] Search Facebook Pages By Location',
  props<{ locationId: string, TypeService:string }>()
)

export const searchPagesByLocationId = createAction(
  '[Facebook] Search Pages By Location Id',
  props<{ locationId: string, authResult: FacebookAuthResult }>()
)

export const searchFacebookPagesByLocationSuccess = createAction(
  '[Facebook] Search Facebook Pages By Location Success',
  props<{ pages: LocationFacebookTokenPair[] }>()
)

export const saveAuthToken = createAction(
  '[Facebook] Save Auth Token',
  props<{ authResult: FacebookAuthResult }>()
)

// TODO: remove locationId once endpoints are moved
export const enableFacebookPage = createAction(
  '[Facebook] Enable Facebook Page',
  props<{ locationId: string, locationTokenId: string }>()
)

export const enableFacebookPageSuccess = createAction(
  '[Facebook] Enable Facebook Page Success',
  props<LocationFacebookTokenPair>()
)

export const disableFacebookPage = createAction(
  '[Facebook] Disable Facebook Page',
  props<{ locationId: string, locationTokenId: string }>()
)

export const disableFacebookPageSuccess = createAction(
  '[Facebook] Disable Facebook Page Success',
  props<LocationFacebookTokenPair>()
)

export const removeFacebookPage = createAction(
  '[Facebook] Remove Facebook Page',
  props<{ locationId: string, locationTokenId: string }>()
)

export const removeFacebookPageSuccess = createAction(
  '[Facebook] Remove Facebook Page Success',
  props<{ locationId: string, locationTokenId: string }>()
)

export const searchScheduleSettings = createAction(
  '[Facebook] Search Schedule Settings',
  props<{ locationId: string }>()
)

export const searchScheduleSettingsSuccess = createAction(
  '[Facebook] Search Schedule Settings Success',
  props<{ settings: SocialSharingScheduleSettings }>()
)

export const updateScheduleSettings = createAction(
  '[Facebook] Update Schedule Settings',
  props<{ settings: SocialSharingScheduleSettings }>()
)

export const updateScheduleSettingsSuccess = createAction(
  '[Facebook] Update Schedule Settings Success',
  props<{ settings: SocialSharingScheduleSettings }>()
)

export const searchTemplateSettings = createAction(
  '[Facebook] Search Template Settings',
  props<{ locationId: string }>()
)

export const searchTemplateSettingsSuccess = createAction(
  '[Facebook] Search Template Settings Success',
  props<{ settings: SocialSharingTemplateSettings }>()
)

export const updateTemplateSettings = createAction(
  '[Facebook] Update Template Settings',
  props<{ settings: SocialSharingTemplateSettings }>()
)

export const updateTemplateSettingsSuccess = createAction(
  '[Facebook] Update Template Settings Success',
  props<{ settings: SocialSharingTemplateSettings }>()
)

export const authenticateFacebook = createAction(
  '[Facebook] Authenticate with Facebook',
  props<{ locationId: string, typeService: FacebookTokenTypes }>()
)

export const setupPagesFromAuthResultForLocation = createAction(
  '[Social Sharing] Setup Pages From AuthResult For Location',
  props<{ authResult: FacebookAuthResult, locationId: string, selectedPageId: any }>()
)

export const shareReview = createAction(
  '[Facebook] Share Review',
  props<{ locationFacebookTokenPair: LocationFacebookTokenPair, reviewId: string }>()
)

export const shareReviewSuccess = createAction(
  '[Facebook] Share Review Success',
  props<{ postUrl?: string }>()
)

export const setSelectedTokens = createAction(
  '[Facebook] Set Selected Tokens',
  props<{ selectedTokens: LocationFacebookTokenPair[] }>()
)

export const sendSelectedToken = createAction(
  '[Facebook] Send Selected Token',
  props<{ payload: {selectedTokens: LocationFacebookTokenPair[], locationId: string} }>()
)

export const openSelectPagesModal = createAction(
  '[Facebook] Open Select Pages Modal',
  props<{ isOpen: Boolean }>()
)

export const setAuthState = createAction(
  '[Facebook] SetAuthState',
  props<{ authState:boolean }>()
)

export const updateCommentOnFacebookPost = createAction(
  '[Facebook] Edit Comment on FacebookPost',
  props<{ request: RequestModel }>()
)

export const updateCommentOnFacebookPostSuccess = createAction(
  '[Facebook] Edit Comment on FacebookPost Success',
  props<{ review: ReviewModel }>()
)
export const commentFacebookPost = createAction(
  '[Facebook] Comment FacebookPost',
  props<{ request: RequestModel }>()
)

export const commentFacebookPostSuccess = createAction(
  '[Facebook] Comment Facebook Post Success',
  props<{ review: ReviewModel }>()
)

export const setFacebookError = createAction(
  '[Facebook] Set Facebook Error',
  props<{ error: FacebookErrorModel }>()
)